// src/services/authService.ts
import apiClient from '../api/apiClient';
import { setAuth, VSAuth } from '../utils/authStorage';

export type RequestOtpResp = { message?: string };
export type VerifyOtpResp = { accessToken?: string; refreshToken?: string; redirect?: string; message?: string; user?: any };

const AUTH_BASE = '/auth/admin';

export const requestOtp = async (tenantId: string, email: string): Promise<RequestOtpResp> => {
    const rel = `${AUTH_BASE}/otp`;
    const { data } = await apiClient.post<RequestOtpResp>(rel, { tenantId, email });
    return data;
};

export const verifyOtp = async (tenantId: string, email: string, otp: string, deviceName?: string, deviceId?: string): Promise<VerifyOtpResp> => {
    const rel = `${AUTH_BASE}/verify`;
    const payload = { tenantId, email, otp, deviceName: deviceName || 'web-client', deviceId: deviceId || 'web-client-001' };
    const { data } = await apiClient.post<VerifyOtpResp>(rel, payload);

    // Save auth session if tokens returned
    if (data?.accessToken && data?.refreshToken) {
        const auth: VSAuth = {
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
            user: data.user ?? { email },
        };
        setAuth(auth);
    }

    return data;
};

export default { requestOtp, verifyOtp };
